import React from 'react';

class Form extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      item: this.props.item?.email
        ? this.props.item
        : {
            name: '',
            lastname: '',
            email: '',
            role: 'instructor',
            school: '',
            status: 'active',
          },
      status: 'init',
      passwordType: 'password',
      passwordGenerated: '',
      changed: false,
    };

    // Bindings
    this.handleChange = this.handleChange.bind(this);
    this.submit = this.submit.bind(this);
  }

  handleChange(e) {
    let item = { ...this.state.item };
    item[e.target.name] = e.target.value;
    item['changed'] = true;
    this.setState({ item });
  }

  submit(e) {
    e.preventDefault();
    const { item } = this.state;
    if (this.props.onSubmit) this.props.onSubmit(item);
  }

  togglePasswordVisibility() {
    const passwordInput = document.querySelector("input[name='password']");
    if (passwordInput) {
      if (passwordInput.type === 'password') {
        passwordInput.type = 'text';
      } else {
        passwordInput.type = 'password';
      }
    }
  }

  generatePassword() {
    // Generate a random password
    const length = 10;
    const charset =
      'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%&*+?.';
    let password = '';
    for (let i = 0, n = charset.length; i < length; ++i) {
      password += charset.charAt(Math.floor(Math.random() * n));
    }
    // Update password input
    const passwordInput = document.querySelector("input[name='password']");
    if (passwordInput) {
      passwordInput.value = password;
      // Set the passwordType to 'text' to make it visible after generation
      this.setState({ passwordType: 'text' });
      // Also trigger the passwordInput change event to update state
      const event = new Event('input', { bubbles: true });
      passwordInput.dispatchEvent(event);
    }
  }

  render() {
    const { item } = this.state;
    const { schools, user } = this.props;

    if (!item) return <h2>Loading...</h2>;
    // console.log({schools})

    const rolesByRole = {
      manager: ['Manager', 'Student', 'Instructor'],
      administrator: ['Administrator', 'Manager', 'Student', 'Instructor'],
    };
    const roleOptions =
      user && user.role
        ? rolesByRole[user.role].map((r, ri) => (
            <option key={`role-${ri}`} value={r.toLowerCase()}>
              {r}
            </option>
          ))
        : [];

    // Filter schools by role
    const filteredSchools =
      user && user.role === 'manager'
        ? schools.filter((s) => s._id === user.school)
        : schools;
    const schoolOptions = filteredSchools.map((s, si) => {
      return (
        <option key={`so-${si}`} value={s._id}>
          {s.name}
        </option>
      );
    });
    const defaultSchool = item.school ? item.school._id : '';

    return (
      <form onSubmit={this.submit}>
        <div className='row'>
          <h2 className='col-12 sec-title' style={{ lineHeight: 1.3 }}>
            User: {item.email || ''}{' '}
            {/* <small 
                style={{ fontSize: '12px', padding: '5px 8px', verticalAlign: 'middle' }} 
                className={ status === 'saving' ? 'text-capitalize badge rounded-pill bg-warning text-white ms-2' : 'text-capitalize badge rounded-pill bg-success text-white ms-2' }>
                { status === 'saving' ? 'saving...' : status }
            </small> */}
            {item.magiclogin && (
              <a
                className='btn btn-link'
                href={item.magiclogin}
                target='_blank'
                rel='noopener noreferrer'
                style={{
                  fontSize: '1rem',
                  padding: '5px 8px',
                  verticalAlign: 'middle',
                }}>
                <small>Log-in as this user</small>
              </a>
            )}
            <div className='float-end' style={{ lineHeight: 1 }}>
              <button className='btn btn-md btn-outline-primary' type='submit'>
                Save
              </button>
            </div>
          </h2>
        </div>

        <div className='row mt-4'>
          <div className='col-3'>
            <div className='mb-3'>
              <label>Name</label>
              <div className='input-group input-group-lg'>
                <input
                  name='name'
                  className='form-control'
                  placeholder='Name'
                  value={item.name || ''}
                  onChange={this.handleChange}
                />
              </div>
            </div>
            <div className='mb-3'>
              <label>Lastname</label>
              <div className='input-group input-group-lg'>
                <input
                  name='lastname'
                  className='form-control'
                  placeholder='Lastname'
                  value={item.lastname || ''}
                  onChange={this.handleChange}
                />
              </div>
            </div>
            <div className='mb-3'>
              <label>Role</label>
              <div className='input-group input-group-lg'>
                <select
                  name='role'
                  value={item.role}
                  className='form-control form-select'
                  onChange={this.handleChange}
                  required>
                  <option value=''>Select role</option>
                  {roleOptions}
                  {/* <option value='administrator'>Administrator</option>
                  <option value='manager'>Manager</option>
                  <option value='student'>Student</option>
                  <option value='instructor'>Instrutor</option> */}
                </select>
              </div>
            </div>
            <div className='mb-3'>
              <label>School</label>
              <div className='input-group input-group-lg'>
                <select
                  name='school'
                  value={defaultSchool}
                  className='form-control form-select'
                  onChange={this.handleChange}>
                  <option value=''>Select</option>
                  {schoolOptions}
                </select>
              </div>
            </div>
          </div>

          <div className='col-3'>
            <div className='mb-3'>
              <label>Email</label>
              <div className='input-group input-group-lg'>
                <input
                  name='email'
                  className='form-control'
                  placeholder='Email'
                  value={item.email || ''}
                  onChange={this.handleChange}
                  required
                />
              </div>
            </div>
            <div className='mb-3'>
              <label>Status</label>
              <div className='input-group input-group-lg'>
                <select
                  name='status'
                  value={item.status}
                  className='form-control form-select'
                  onChange={this.handleChange}
                  required>
                  <option value=''>Select status</option>
                  <option value='created'>Created</option>
                  <option value='active'>Active</option>
                  <option value='recovery'>Recovery</option>
                  <option value='deleted'>Deleted</option>
                </select>
              </div>
            </div>
            <div className='mb-3'>
              <label>Password</label>
              <button
                className='btn btn-link btn-sm ms-2'
                type='button'
                onClick={() => this.generatePassword()}>
                Generate
              </button>
              <div className='input-group input-group-lg'>
                <input
                  name='password'
                  className='form-control'
                  type={this.state.passwordType}
                  placeholder='Password'
                  onChange={this.handleChange}
                />
                {/* Show/Hide button */}
                <button
                  className='btn btn-outline-secondary'
                  type='button'
                  onClick={() => this.togglePasswordVisibility()}>
                  {this.state.passwordType === 'password' ? 'Show' : 'Hide'}
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    );
  }
}

export default Form;
